/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IEcommUpcomingProgrammes contentModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export const enum organisation {
    bt = 'bt',
    gp = 'gp'
}

export const enum eventType {
    all = 'all',
    ceremony = 'ceremony',
    grouppractice = 'grouppractice'
}

export interface IEcommUpcomingProgrammesConfig extends Msdyn365.IModuleConfig {
    title: string;
    bgImage?: Msdyn365.IImageData;
    cardButtonText?: string;
    organisation?: organisation;
    eventType?: eventType;
    portalUrl: Msdyn365.ILinkData;
    redirectPortal: boolean;
    eventPdpUrl: Msdyn365.ILinkData;
    productPdpUrl: Msdyn365.ILinkData;
    dateRange: number;
    isUat: boolean;
    calendarLink?: ICalendarLinkData;
    sliderSpeed?: number;
    displayMobileDropdown: boolean;
    mobileDropdownPageSize: number;
}

export interface ICalendarLinkData {
    linkText: string;
    linkUrl: Msdyn365.ILinkData;
    ariaLabel?: string;
}

export interface IEcommUpcomingProgrammesProps<T> extends Msdyn365.IModule<T> {
    config: IEcommUpcomingProgrammesConfig;
}
